import { Route, useHistory } from "react-router-dom";
import { ThemeProvider } from "./lib/components/ThemeProvider";
import { GlobalStyle } from "./lib/styles/global";

import { Home } from "./apps/home";
import { Phish } from "./apps/phish";
import { Customers } from "./apps/customers";
import { Soc } from "./apps/soc";
import { FeatureFlagProvider } from "lib/feature-flagging/FeatureFlagProvider";
import { RegionProvider } from "lib/components/RegionProvider";
import { AuthContextProvider } from "./entra-auth/auth-context-provider.tsx";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "entra-auth/navigation-client";
import { FlagScript } from "lib/feature-flagging/FlagScript";
import { CookiesProvider } from "react-cookie";
import { SlotSwitcher } from "lib/components/SlotSwitcher";

const App = ({ msalInstance }) => {
  const navigate = useHistory();
  const navigationClient = new CustomNavigationClient(navigate);
  msalInstance.setNavigationClient(navigationClient);

  return (
    <CookiesProvider>
      <FeatureFlagProvider>
        <FlagScript />
        <ThemeProvider>
          <SlotSwitcher />
          <MsalProvider instance={msalInstance}>
            <AuthContextProvider>
              <RegionProvider>
                <Route path="/phish" component={Phish} />
                <Route path="/customers" component={Customers} />
                <Route path="/soc" component={Soc} />
                <Route path="/" exact component={Home} />
              </RegionProvider>
            </AuthContextProvider>
          </MsalProvider>
          <GlobalStyle />
        </ThemeProvider>
      </FeatureFlagProvider>
    </CookiesProvider>
  );
};

export default App;
